<template>
  <div class="ai-preparation-container">
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 顶部按钮组 -->
      <div class="button-group">
        <button v-for="button in mainButtons" :key="button.id" class="main-button"
          :class="{ active: activeMainButton === button.id }" @click="handleMainButtonClick(button.id)">
          {{ button.label }}
        </button>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 自媒体训练内容 -->
        <SelfMediaTraining 
          v-if="activeMainButton === 'selfMedia'" 
          :key="'selfMedia'"
        />
        
        <!-- 智能体官网训练内容 -->
        <AIAgentTraining 
          v-else-if="activeMainButton === 'aiAgent'" 
          :key="'aiAgent'"
        />

        <!-- 共享账号池内容 -->
        <AccountPoolManagement 
          v-else-if="activeMainButton === 'accountPool'" 
          :key="'accountPool'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelfMediaTraining from '@/components/SelfMediaTraining.vue'
import AIAgentTraining from '@/components/AIAgentTraining.vue'
import AccountPoolManagement from '@/components/AccountPoolManagement.vue'

export default {
  name: 'AiAuth',
  components: {
    SelfMediaTraining,
    AIAgentTraining,
    AccountPoolManagement
  },
  data() {
    return {
      activeMainButton: 'selfMedia',
      
      // 主按钮配置 - 新增共享账号池
      mainButtons: [
        { id: 'selfMedia', label: '自媒体训练' },
        { id: 'aiAgent', label: '智能体官网训练' },
        { id: 'accountPool', label: '共享账号池' }
      ]
    }
  },
  methods: {
    handleMainButtonClick(buttonId) {
      this.activeMainButton = buttonId
    }
  }
}
</script>

<style scoped lang="scss">
.ai-preparation-container {
  padding: 24px;
  min-height: calc(100vh - 160px);
  background: transparent;
}

.main-content {
  background: hsla(0, 0%, 100%, .1);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.button-group {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.main-button {
  padding: 12px 24px;
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #e0e6ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7048;
    border-color: #ff7048;
    transform: translateY(-2px);
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }
}

.content-area {
  min-height: 500px;
}

// 响应式设计
@media (max-width: 768px) {
  .ai-preparation-container {
    padding: 16px;
  }

  .button-group {
    gap: 12px;

    .main-button {
      padding: 10px 20px;
      font-size: 13px;
    }
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 16px;
  }

  .button-group {
    justify-content: center;
  }
}
</style>